/**
 * Rendered only in the /epk page!
 */
import styled from 'styled-components';
import { TextContent } from './components';
import { epkLinks } from './data/epkLinks';

export const EPKBandBio = () => {
  const file = epkLinks.find((i) => i.id === 'bio');
  return (
    <TextContent>
      <p>Allochiria is a metal band formed in Athens, Greece in 2008.</p>
      <p>
        With a fine balance of post-metal, sludge, progressive and hardcore
        elements, their music is thematic; it revolves around humans as social
        beings, the corruption that defines them in modern societies, their vain
        struggles, painful routines and the consequences of their actions in the
        world around them.
      </p>
      <p>
        Allochiria have released one EP (2010) and three full-length albums:{' '}
        <b>Omonoia</b> (2014), <b>Throes</b> (Art of Propaganda, 2017) and{' '}
        <b>Commotion</b> (Venerate Industries, 2023).
      </p>
      <p>
        The band has a long history of countless live shows and festivals
        throughout the years, alongside multiple European tours, in the latest
        one of which they co-headlined 7 shows with DVNE (UK). Allochiria have
        shared the stage with Botch, Social Distortion, Amenra, Deafheaven,
        Altar of Plagues, Harakiri for the Sky, Deaf Kids, and more. They have
        played in Desertfest Athens, Rockstadt Extreme Fest in Romania and
        Rockwave Festival Athens.
      </p>
      <p>
        Currently Allochiria are working on their 4th studio album and planning
        their next shows.
      </p>
      <p>
        <Link
          href={file.link}
          title={file.label}
          target="_blank"
          rel="noreferrer"
        >
          Download biography (pdf)
        </Link>
      </p>
      <p>
        <Link href="/shows-archive" target="_blank" rel="noreferrer">
          Full list of Allochiria's past shows (opens new browser tab)
        </Link>
      </p>
    </TextContent>
  );
};

const Link = styled.a`
  color: black;
`;
